module.exports = __webpack_public_path__ + "assets/img/header-bg-2.c3e7ed9c.png";